// extracted by mini-css-extract-plugin
export default {"columns":"Admin_columns__FGBU9","mainContainer":"Admin_mainContainer__RtHaT","ruc":"Admin_ruc__Wd-TB","cambios":"Admin_cambios__33HiK","cambio":"Admin_cambio__rQqqY"};